/**
 * Плавно скроллит страницу наверх с задержкой 1000ms.
 * Сайд-эффект: вызывает `window.scrollTo` через setTimeout.
 */
export const scrollToTop = function () {
  setTimeout(() => {
    window?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, 1000);
};
